export function authHeader() {
  let user =
    JSON.parse(sessionStorage.getItem("user")) ??
    JSON.parse(localStorage.getItem("user"));
  if (user && user.access_token) {
    return {
      Authorization: "Bearer " + user.access_token,
      "x-timezone": user.user_timezone,
    };
  } else {
    return {};
  }
}

export function authHeaderWithMultipartData() {
  let user =
    JSON.parse(sessionStorage.getItem("user")) ??
    JSON.parse(localStorage.getItem("user"));
  if (user && user.access_token) {
    return {
      Authorization: "Bearer " + user.access_token,
      "x-timezone": user.user_timezone,
      "Content-Type": "multipart/form-data",
    };
  } else {
    return {};
  }
}

export function authDeviceHeader() {
  let user =
    JSON.parse(sessionStorage.getItem("user")) ??
    JSON.parse(localStorage.getItem("user"));
  if (user && user.access_token) {
    return {
      Authorization: "Bearer " + user.access_token,
    };
  } else {
    return {};
  }
}

export function authDeviceFormHeader() {
  return {
    "Content-Type": "multipart/form-data",
  };
}

export function authDeviceWithDomainHeader() {
  let user =
    JSON.parse(sessionStorage.getItem("user")) ??
    JSON.parse(localStorage.getItem("user"));
  let domain_uuid = sessionStorage.getItem("domain_uuid");
  if (user && user.access_token) {
    return {
      Authorization: "Bearer " + user.access_token,
      domain_uuid: domain_uuid,
    };
  } else {
    return {};
  }
}

export function authWithDomainHeader(domain_id) {
  let user =
    JSON.parse(sessionStorage.getItem("user")) ??
    JSON.parse(localStorage.getItem("user"));
  if (user && user.access_token) {
    return {
      Authorization: "Bearer " + user.access_token,
      domain_uuid: domain_id,
    };
  } else {
    return {};
  }
}

export function authWithRefresh() {
  let token = localStorage.rfToken
    ? localStorage.getItem("rfToken")
    : sessionStorage.user
    ? JSON.parse(sessionStorage.getItem("user")).refresh_token
    : null;
  return token ? { Authorization: "Bearer " + token } : {};
}
